import { useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useClientByIdQuery, useClientTypeQuery, useLanguageQuery } from 'api';
import { useCountryMapping } from 'hooks/useCountryMapping';

export const useDetails = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { id } = useParams() as { id: string };
  const { countryMapping } = useCountryMapping();
  const { data: clientDetails = {} } = useClientByIdQuery({ id });
  const { data: clientTypeData = [] } = useClientTypeQuery();
  const { data: languageData = [] } = useLanguageQuery();

  const countryDetails = useMemo(() => {
    return countryMapping[clientDetails.countryId] || {};
  }, [countryMapping, clientDetails]);
  const languageDetails = useMemo(() => {
    return languageData.find((_record: Record<string, any>) => _record.id === clientDetails.languageId) || {};
  }, [languageData, clientDetails]);
  const typeDetails = useMemo(() => {
    return clientTypeData.find((_record: Record<string, any>) => _record.id === clientDetails.clientTypeId) || {};
  }, [clientTypeData, clientDetails]);
  const onModalClose = useCallback(() => {
    setIsOpen(false);
  }, []);
  const onModalOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  return {
    isOpen,
    onModalClose,
    onModalOpen,
    clientDetails,
    languageDetails,
    countryDetails,
    typeDetails,
  };
};
